import { Input, Flex as WebFlex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.js';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { calculations } from '../utils/formatters/calculations.ts';
import { PairedCostSettingsBreakdown } from './PairedCostSettingsBreakdown.tsx';
import { isCosted } from './isCosted.ts';

export const AdjustmentBreakdownBasement = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const commentaryProps = props.exportableCommentaries.basement;
  const [commentary, setCommentary] = useState(commentaryProps.commentary);

  if (!isCosted(props.results, 'basement')) {
    return null;
  }
  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title="Basement Adjustment"
        id="isBasementCommentaryInExport"
        commentary={commentaryProps}
      />
      <Typography variant="body1">
        The basement adjustment is calculated by subtracting the comparable basement value from the
        subject’s basement value. The basement value accounts for the size of the basement, the
        extent of the finishes, and the bathrooms.
      </Typography>
      <PDFOnly>
        <Typography variant="body1">{commentaryProps.commentary}</Typography>
      </PDFOnly>
      <SummaryTableHorizontal
        {...props}
        compSequence={props.compSequence}
        summary={props}
        columns={[
          {
            header: 'Square Feet',
            type: 'feature',
            path: 'text',
            adjustmentType: 'basement',
          },
          {
            header: 'Adjustment Calculation',
            type: 'adjustment',
            path: 'calculations',
            valueFormatter: calculations,
            adjustmentType: 'basement',
          },
          {
            header: 'Adjustment',
            type: 'adjustment',
            path: 'adjustment',
            valueFormatter: adjustment,
            textAlign: 'right',
            adjustmentType: 'basement',
            includeTooltip: true,
          },
          {
            header: 'Price / SF',
            type: 'feature',
            path: 'costPerSqft',
            adjustmentType: 'basement',
          },
        ]}
      />
      <PairedCostSettingsBreakdown {...props} type="basement" />
      <WebOnly>
        <WebFlex marginTop="1rem" width="40rem">
          <Input
            type="multiline"
            onChange={setCommentary}
            value={commentary}
            onClear={() => setCommentary('')}
            onBlur={() => commentaryProps.updateCommentary(commentary)}
            resize="both"
            label="Commentary"
            size="sm"
          />
        </WebFlex>
      </WebOnly>
    </SummarySection>
  );
};
